import { IDataSet } from '../Track';

export class ConnectionDataSet implements IDataSet {
    public gbSessionNumber: number = undefined;
    public gbDisconnectTime: number = undefined;
    public gbInitializeTime: number = undefined;
    public gbFailBeforeSuccess: number = undefined;
    public gbError: string = undefined;
}
